import * as React from 'react';
import { connect } from 'react-redux';
import { Action, Dispatch } from 'redux';
import {
  markerAppend,
  markerDelete,
  markerModify,
  markerToolSetColorIndex,
} from '../../marker/actions/MarkerAction';
import { AppStates } from '../../../../..';
import { SelectionState, SelectionType } from '../../reducers/selection';
import { MarkerToolState } from '../../marker/reducers/marker';
import { find } from '../../../../../common/src/ts/utils';
import { UIMode } from '../../../../../common/src/ts/types/UIMode';
import { MarkerInfo } from '../../marker';
import LineColorRadioButtonSet from '../common/LineColorRadioButtonSet';
import ToolIconButton from '../common/ToolIconButton';

interface MarkerMenuProps {
  dispatch: Dispatch<Action>;
  uimode: UIMode;
  selection: Readonly<SelectionState>;
  markerTool: Readonly<MarkerToolState>;
  markerInfo: Readonly<MarkerInfo> | undefined;
}

class MarkerMenu extends React.Component<MarkerMenuProps> {

  public shouldComponentUpdate(nextProps: MarkerMenuProps): boolean {
    const { uimode, selection, markerTool, markerInfo } = this.props;
    return uimode !== nextProps.uimode
           || selection !== nextProps.selection
           || markerTool !== nextProps.markerTool
           || markerInfo !== nextProps.markerInfo;
  }

  private onTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { props: { dispatch, selection } } = this;
    if (selection.type === SelectionType.MARKER) {
      dispatch(markerModify(selection.id, { title: e.target.value }));
    }
  }

  public render() {
    const { props: { selection, markerTool, markerInfo } } = this;
    switch (selection.type) {
      case SelectionType.RANGE:
        return <>
          <LineColorRadioButtonSet
            key="markermenu-color"
            activeIndex={markerTool.colorIndex}
            onClick={this.handleColorChange}/>
          <ToolIconButton
            key="markermenu-create-marker"
            onClick={this.setMarker}
            title="マーカ作成"
            iconName="pen-2" />
        </>;
      case SelectionType.MARKER: {
        const inputStyle: React.CSSProperties = {
          backgroundColor: 'inherit',
          color: 'inherit',
          margin: '4px',
          padding: '7px',
        };
        return <>
          <LineColorRadioButtonSet
            key="markermenu-color"
            activeIndex={-1}
            onClick={this.handleColorChange}/>
          <ToolIconButton
            key="markermenu-delete"
            onClick={this.deleteMarker}
            title="マーカ削除"
            iconName="object-removal" />
          <input type="text"
            key="markermenu-title"
            placeholder="title"
            onChange={this.onTitleChange}
            value={ markerInfo!.title }
            style={inputStyle}/>
        </>;
      }
    }
    return <>
      <LineColorRadioButtonSet
        key="markermenu-color"
        activeIndex={markerTool.colorIndex}
        onClick={this.handleColorChange}/>
    </>;
  }

  private setMarker = () => {
    const { props: { dispatch, selection, markerTool } } = this;
    if (selection.type !== SelectionType.RANGE) {
      return;
    }
    // XXX: Mock
    const colors = [
      'rgba(255, 0, 0, 0.25)',
      'rgba(0, 0, 255, 0.25)',
      'rgba(255, 255, 0, 0.25)',
      'rgba(0, 128, 0, 0.25)',
      'rgba(0, 0, 0, 0.25)',
    ];
    const color = colors[markerTool.colorIndex];
    dispatch(
      markerAppend({
        reference: selection.cfi,
        style: `background-color: ${color};`,
        text: selection.text,
      }),
    );
  }

  private handleColorChange = (colorIndex: number) => {
    const { props: { dispatch, selection } } = this;
    if (selection.type === SelectionType.MARKER) {
      const colors = [
        'rgba(255, 0, 0, 0.25)',
        'rgba(0, 0, 255, 0.25)',
        'rgba(255, 255, 0, 0.25)',
        'rgba(0, 128, 0, 0.25)',
        'rgba(0, 0, 0, 0.25)',
      ];
      const color = colors[colorIndex];
      dispatch(markerModify(selection.id, { style: `background-color: ${color};` }));
    } else {
      dispatch(markerToolSetColorIndex(colorIndex));
    }
  }

  private deleteMarker = () => {
    const { props: { dispatch, selection } } = this;
    if (selection.type !== SelectionType.MARKER) {
      return;
    }
    dispatch(markerDelete(selection.id));
  }
}

export default connect(
  (state: AppStates) => {
    const { uimode: { mode: uimode }, selectionState: selection, markerTool, markers } = state;
    return {
      uimode, selection, markerTool,
      markerInfo: selection.type === SelectionType.MARKER
                  ? find(markers, marker => marker.id === selection.id)
                  : undefined,
    };
  },
)(MarkerMenu);
